<template>
  <div class="style-guide-container">
    <GuidesSkeletonLoader v-if="pageLoading" />

    <div v-else>
      <h5
        v-if="!styleGuideItems.length"
        class="pt-6"
      >
        There is no style guide defined for your project
      </h5>
      <GuidesTabs :tabs="styleGuideItems">
        <template #tab-content="{ items, comingSoon }">
          <NoEditorWrapper
            v-for="item in items"
            :key="item.id"
          >
            <StyleForm
              :style-item="item"
              :coming-soon="comingSoon"
              @submit="submit"
            />
          </NoEditorWrapper>
        </template>
      </GuidesTabs>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { useAppLoading } from '@/stores/app/loading';
import { useSettingsConfig } from '@/stores/settings/config';
import { useSettingsGuides } from '@/stores/settings/guides';
import GuidesSkeletonLoader from '@/components/shared/SkeletonLoaders/settings/GuidesSkeletonLoader.vue';
import GuidesTabs from '@/components/settings/components/GuidesTabs.vue';
import NoEditorWrapper from '@/components/editor/NoEditorWrapper.vue';
import StyleForm from './StyleForm.vue';

export default {
  name: 'StyleGuide',
  components: {
    NoEditorWrapper,
    StyleForm,
    GuidesTabs,
    GuidesSkeletonLoader,
  },
  computed: {
    ...mapState(useAppLoading, ['pageLoading']),
    ...mapState(useSettingsGuides, ['styleGuideItems']),
    ...mapState(useSettingsConfig, ['config']),
  },
  async mounted() {
    await this.loadGuides();
  },
  methods: {
    ...mapActions(useSettingsGuides, ['loadGuides', 'submit']),
  },
};
</script>

<style scoped lang="less">
.style-guide-container {
  width: 100%;
}
.style-forms-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.style-group {
  font-weight: 700;
}

.style-group-container:not(:first-child) {
  margin-top: 24px;
}
</style>
